// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fc75216b","270":"dea90bc6"}[chunkId] + ".chunk.js";
};